<div id="setting-screen">
  <header>
    驗證頁面
  </header>
  <div id="content">
    <input type="text" placeholder="驗證碼" [(ngModel)]="code" /><br>
    <button (click)="verify()">驗證</button>
  </div>
</div>
